var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-btn',{on:{"click":_vm.exportFile}},[_vm._v(_vm._s(_vm.$t('BUTTON.EXPORT')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }